import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

const DonutClock = ({ before, value, after, label, labelKey }) => (
    <div className="item my-1">
        <div className="inner">
            <div className="circle">
                <svg viewBox="0 0 38 38" className="img-fluid">
                    <path fill="#fff" d="M16.5.2h5V2h-5V.2zm-13 6.6l.8.9 1.3-1.3 1.1 1 .9-.9-1-1 1.3-1.3-1-1-3.5 3.6zM31 3.3l-.9.8 1.3 1.4-1 1 .9 1 1-1.1 1.4 1.3.8-.9L31 3.3z" />
                    {/* eslint-disable-next-line max-len */}
                    <path fill="#fff" d="M6.4 23.6v.2l-.2.1-.4.2h-.1a.3.3 0 01-.3-.3c0-.1 0-.2.2-.2l.4-.2h.1c.2 0 .3 0 .3.2zm-.7-2l.1-.3c0-.1-.1-.2-.3-.2H5l-.2.3v.2l.2.1h.6l.2-.2zm1-2.3l.2-.3c0-.2-.1-.3-.3-.3H4.8c-.1 0-.2.1-.2.3 0 .1 0 .3.2.3h1.8zM5 16.8l.5.1c.2 0 .3-.1.3-.2 0-.2 0-.3-.2-.4H5c-.2 0-.3 0-.3.2 0 .1 0 .3.2.3zm5.4 12.4h-.2-.2l-.3.4-.1.2c0 .1.1.3.3.3l.2-.1.3-.4v-.2-.2zm2.4.4l-.3.1-.8 1.4V31.4h.4L13 30c.1-.1 0-.3 0-.4zm-4.5-4.4l-.2-.1h-.2l-1.3.7-.2.2c0 .2.2.3.3.3H7l1.3-.7c.2-.1.2-.3.1-.4zm.2 2.3h-.2l-.3.3-.1.2c0 .2 0 .3.2.3h.2l.4-.4.1-.1v-.3h-.3zm-3-13l.5.1h.1c.2 0 .3 0 .3-.2v-.2l-.2-.1-.4-.2h-.1c-.2 0-.3 0-.3.2v.2l.2.1zm24.1-1.8c0 .1.1.2.3.2h.1l1.4-.7c.1 0 .2-.3 0-.4l-.2-.1h-.1l-1.3.7-.2.3zm-.2-2.2h.2l.4-.4v-.3l-.2-.2-.2.1-.3.3-.1.2c0 .2 0 .3.3.3zM6.6 12.2l1.3.8h.2l.2-.1-.1-.4-1.3-.8h-.2l-.2.1v.4zm25.6 4.4c0 .2 0 .3.2.3h.6l.2-.4c0-.1-.1-.2-.3-.2h-.5l-.2.3zm-.4-2h.1l.5-.2.2-.3-.3-.2h-.1l-.5.2-.2.2c0 .2.2.3.3.3zM8.3 10.4l.2.1h.2v-.3-.2l-.4-.3h-.2H8v.4l.4.3zM10 8.8l.2.1h.2c0-.1.1-.3 0-.4l-.3-.4a.3.3 0 00-.4.4l.3.3zm2.5-.4l.2.1h.1l.2-.2V8L12 6.6l-.2-.1h-.1c-.2.1-.2.3-.1.4l.8 1.4zm15.3.5h.2l.3-.4V8H28h-.2l-.3.4-.1.2c0 .1.1.2.3.2zM14.4 31.5h-.1c-.1 0-.2 0-.3.2l-.1.4v.1c0 .2 0 .3.2.3s.3 0 .3-.2l.2-.4v-.2l-.2-.2zm17-5.7l-1.4-.7H29.7v.5l1.4.7h.1l.3-.1-.1-.4zM28 29.2h-.4l-.1.2v.2l.4.4H28.2l.1-.2v-.2l-.3-.4zm1.6-1.7h-.2-.2v.5l.4.3h.4V28 28l-.4-.4zm-4 2.2l-.3-.1h-.1l-.1.2v.2l.7 1.4h.4c.1 0 .2-.2.1-.3l-.7-1.4zm-.3-21.3l.2-.1.8-1.4-.1-.4h-.1l-.3.1L25 8V8.3l.3.1zm7 15.2l-.4-.2-.3.1.1.4.5.2c.2 0 .3 0 .3-.2.1-.1 0-.3-.1-.3zm.8-4.9h-2.3c-.1 0-.2.1-.2.3 0 .1 0 .3.2.3h2.3c.2 0 .3-.2.3-.3 0-.2-.1-.3-.3-.3zm-.1 2.5l-.5-.1c-.2 0-.3 0-.3.2s0 .3.2.3l.5.1c.2 0 .3 0 .3-.2s0-.3-.2-.3zM21.6 32.4c0-.2-.1-.3-.3-.3l-.2.1v.7c0 .2.2.3.3.3.2 0 .2 0 .3-.2V32.4zm-5-.3l-.3.3V33l.2.2c.2 0 .3-.1.3-.3v-.4c.1-.1 0-.2 0-.2l-.1-.2zM19 4.6c-.2 0-.3.1-.3.3v1.8c0 .1.1.3.3.3l.3-.3V4.9c0-.2-.2-.3-.3-.3zm5 .9h-.2l-.2.1-.2.5V6.4h.3l.2-.1.2-.5v-.2l-.2-.1zm-7.7.1c0 .2.2.3.3.3.2 0 .3-.2.3-.4l-.1-.4c0-.2-.1-.3-.3-.3l-.2.1v.7zM19 31c-.2 0-.3.1-.3.3V33c0 .1.1.2.3.2.1 0 .3 0 .3-.2v-1.8c0-.2-.2-.3-.3-.3zm5 .7l-.3-.2h-.1c-.2 0-.3.2-.2.4l.2.5.2.1h.1c.2 0 .2-.2.2-.4l-.2-.4zm-9.6-26c0-.2-.1-.3-.3-.3-.2.1-.3.3-.2.4l.2.5.2.2h.1l.2-.2v-.2l-.2-.5zm7-.9c-.1 0-.2.1-.2.3l-.1.4c0 .2 0 .3.2.4.2 0 .3-.1.3-.3l.1-.4v-.3h-.2z" clipRule="evenodd" />
                    <circle className="circle-bg" cx="19" cy="19" r="16" fill="none" strokeWidth="2" />
                    <circle transform="rotate(-90 19 19)"
                        className="circle-highlight"
                        fill="none"
                        stroke="#C40E0E"
                        strokeWidth="2"
                        strokeMiterlimit="10"
                        strokeDasharray="62.5, 100"
                        cx="19"
                        cy="19"
                        r="16" />
                </svg>
            </div>

            <div className="text">
                <span className="display-2">
                    <sub>{before}</sub>
                    {value}
                    <sup style={{ fontSize: '30%' }}>{after}</sup>
                    {/* <sup style="{{ $stat['after'] == 'SECS' ? 'font-size: 30%' : '' }}"></sup> */}
                </span>
                <label className="px--1">{label}<sup>{labelKey}</sup></label>
            </div>
        </div>
    </div>
);

DonutClock.propTypes = {
    before: PropTypes.string,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    after: PropTypes.string,
    label: PropTypes.string,
    labelKey: PropTypes.number,
};

DonutClock.defaultProps = {
    before: '',
    value: '',
    after: '',
    label: '',
    labelKey: '',
};

export default DonutClock;
